// Quotation Prepare for signature Stage related codes goes here

// NPM Imports
import React, { Component } from "react";
import { Button } from "@revvsales/components";

// Components Imports

class QuotationPrepareForSignatureBtns extends Component {
  state = {};

  render() {
    return (
      <div>
        <Button
          className="revv-btn-secondary"
          onClick={() =>
            this.props.togglePopUp("showConfirmCancleEsignPopup", true)
          }
          id={"CancleESignaturee".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationtopbar-upgrade-stage-btn">
          Cancel
        </Button>
        <Button
          className="send-document"
          isLoading={this.props.showBtnLoader}
          onClick={() => this.props.togglePopUp("sendForSignature", true)}
          id={"Send".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationtopbar-upgrade-stage-btn">
          Share document
        </Button>
      </div>
    );
  }
}

export default QuotationPrepareForSignatureBtns;



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/QuotationPrepareForSignatureBtns.js